import { useState, useEffect, useRef, Dispatch } from 'react'
import { Config } from '../../App'
import { Feature, Map, View } from "ol";
import TileLayer from "ol/layer/Tile";
import { OSM } from "ol/source";

import DownArrowImg from "../../shared/icons/images/downArrow.svg"
import ShowMoreImg from "../../shared/icons/images/showMore.svg"
import ContactUs from "../../shared/icons/contactUsInvert.svg"
import VKLogo from "../../shared/icons/VKLogo.svg"
import TGLogo from "../../shared/icons/TGLogo.svg"
import SAMISLogo from "../../shared/icons/SAMISLogo.svg"
import NextArrow from "../../shared/assets/nextArrow.svg"
import CatImg from "../../shared/assets/cat.jpg"
import PlusImg from "../../shared/assets/plus.svg"
import GeocoderBackground from "../../shared/assets/back.svg"

import CompareTruthImg from "../../shared/images/geocoder_compare_truth.png";
import CompareTimeImg from "../../shared/images/geocoder_compare_time.png";


//@ts-ignore
import axios from 'axios';

import { Geometry } from 'ol/geom';
import { Fill, Stroke, Style } from 'ol/style';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import GeoJSON from 'ol/format/GeoJSON';
//@ts-ignore
import { toWgs84, toMercator } from "@turf/projection";

import { useDispatch, useSelector } from 'react-redux';
import { setContactOpened } from '../../shared/StoreContainer/actionCreators';
import { GetContact } from '../../features/get-contact';
import { sendMetricContacts } from '../../shared/MetricApi';

import './style.css'
import ReactJson from 'react-json-view';

type UserContactType = {
    name: string,
    email: string,
    phone: string,
    comment: string
}

export const NewDemo = () => {

    const [showMore, setShowMore] = useState<number | null>(null);

    const mapElement = useRef<HTMLInputElement>(null)
    const mapRef = useRef<Map>();

    const idInContainer = useSelector((state: any) => (state?.containerUser?.user?.id));

    const [address, setAddress] = useState<string>("");

    const [userContact, setUserContact] = useState<UserContactType>({ name: "", email: "", phone: "", comment: "" })

    const [lastClicked, setLastClicked] = useState<[number, number] | null>(null);

    const [lastResponse, setLastResponse] = useState<{ [key: string]: any } | null>(null);

    const [geocoderToken, setGeocoderToken] = useState<string | null>(null);

    useEffect(() => {

        let url = "https://rk.geosamara.ru/geocoder/token";

        fetch(url, {
            method: "GET",
            credentials: 'include'
        })
            .then((response: any) => {
                console.log('aboba_1')
                response.json().then((j: any) => {
                    setGeocoderToken(j && j.token)
                })
            })
            .catch(error1 => {
                console.log('aboba_2')
                fetch(url, { method: "POST" })
                    .then((response2: any) => {
                        response2.json().then((j: any) => setGeocoderToken(j && j.token));
                    })
                    .catch((error2: any) => {
                        console.log("get token", error2)
                    })
            })

    }, [])

    const getAddress = (sandbox: 'geocode' | 'decompose') => {
        setLastResponse(null);
        if (sandbox === 'geocode') {
            const basePath = `https://rk.geosamara.ru/geocoder/geocode?token=${geocoderToken}&`;
            const url = new URLSearchParams();

            const data = {} as { [key: string]: string | number };
            address && address.length > 0 && Object.assign(data, { "address": address });
            lastClicked && Object.assign(data, { "lat": lastClicked[0], "lon": lastClicked[1] })

            Object.keys(data).forEach(key => {
                url.append(key, JSON.stringify(data[key]));
            })

            fetch(basePath + url.toString(), { method: "GET" })
                .then(r => {
                    r.json().then((response: any) => {
                        console.log(response);
                        setAddress(response.features[0].properties.result);
                        setLastResponse(response.features[0]);
                    })
                })
                .catch((error: any) => {
                    console.log({ error })
                    setLastResponse({ "Ошибка": "Ваши бесплатные запросы закончились. Зарегистрируйтесь, получите свой токен и работайте дальше с Геокодером." });
                })
        }
        else if (sandbox === 'decompose') {
            const basePath = `https://rk.geosamara.ru/geocoder/decompose?token=${geocoderToken}&`;
            const url = new URLSearchParams();


            const data = {} as { [key: string]: string | number };
            address && address.length > 0 && Object.assign(data, { "address": address });

            Object.keys(data).forEach(key => {
                url.append(key, JSON.stringify(data[key]));
            })

            fetch(basePath + url.toString(), { method: "GET" })
                .then(r => {
                    r.json().then((response: any) => {
                        console.log(response);
                        setLastResponse(response);
                    })
                })
                .catch((error: any) => {
                    console.log({ error })
                    setLastResponse({ "Ошибка": "Ваши бесплатные запросы закончились. Зарегистрируйтесь, получите свой токен и работайте дальше с Геокодером." });
                })
        }
    }

    const updUserContact = (key: keyof UserContactType, value: string) => {
        const copy = JSON.parse(JSON.stringify(userContact));
        copy[key] = value;
        setUserContact(copy);
    }

    useEffect(() => {
        lastClicked && getAddress('geocode');
        //eslint-disable-next-line
    }, [lastClicked])

    useEffect(() => {
        if (lastResponse && lastResponse.geometry) {
            let feature = new GeoJSON().readFeature({
                'type': 'Feature',
                'geometry': lastResponse.geometry
            }) as Feature<Geometry>

            feature = new GeoJSON().readFeature((toMercator(JSON.parse(new GeoJSON().writeFeature(feature))))) as Feature<Geometry>;

            feature.setStyle(new Style({
                stroke: new Stroke({
                    color: "#ff0000"
                }),
                fill: new Fill({
                    color: "rgba(255,0,0,0.47)"
                })
            }))

            let vectorSource = new VectorSource({ features: [feature] });
            let vectorLayer = new VectorLayer({ source: vectorSource });
            vectorLayer.set('name', 'vLayer');

            const prevLayer = mapRef.current?.getAllLayers().find(layer => layer.get('name') === 'vLayer');
            prevLayer && mapRef.current?.removeLayer(prevLayer);
            mapRef.current?.addLayer(vectorLayer);

            const ext = feature.getGeometry()?.getExtent();
            ext && mapRef.current?.getView().fit(ext, { padding: [30, 30, 30, 30] });
        }
        else {
            const prevLayer = mapRef.current?.getAllLayers().find(layer => layer.get('name') === 'vLayer');
            prevLayer && mapRef.current?.removeLayer(prevLayer);
        }
    }, [lastResponse])

    useEffect(() => {
        if (mapElement
            && mapElement.current
            && !mapRef.current
        ) {

            mapRef.current = new Map({
                target: mapElement.current,
                layers: [
                    new TileLayer({
                        preload: Infinity,
                        source: new OSM(),
                    })
                ],
                view: new View({
                    center: [5584030.684758671, 7021364.820491779],
                    zoom: 12.2,
                    maxZoom: 24
                })
            });

            mapRef.current && mapRef.current.on('click', (event) => {
                const coords = toWgs84(event.coordinate);
                setLastClicked([coords[1], coords[0]]);
            })
        }
    }, [mapElement])

    return <>
        {/*<div className="header">
            <img src={SAMISLogo} alt="" className="header__company" onClick={() => window.location.assign("#info-container")} />

            <nav className="header__navigation">
                <div className="navigation__links-container">
                    <a href="#info-container" className="links-container__link-item">Главное</a>
                    <a href="#functions-container" className="links-container__link-item">Возможности</a>
                    <a href="#info-container-more-info" className="links-container__link-item">Для кого</a>
                    <a href="#advantages-container" className="links-container__link-item">Преимущества</a>
                    <a href="#sandbox" className="links-container__link-item">Попробовать</a>
                    <a href="#tarifs-container" className="links-container__link-item">Тарифы</a>
                    <a href="#about-company" className="links-container__link-item">О компании</a>
                </div>
                <div className="navigation__social-container">
                    <img src={ContactUs} className="social-container__social-item" onClick={() => window.location.assign("#contact-us-container")} />
                    <img src={ContactUs} className="social-container__social-item" onClick={() => window.location.assign("#contact-us-container")} />
                    <img src={ContactUs} className="social-container__social-item" onClick={() => window.location.assign("#contact-us-container")} /> 
                </div>
            </nav>

            <button className="header__contacts-button" onClick={() => window.location.assign("#contact-us-container")} >Связаться</button>
        </div>

        <div className="info-container" id="info-container">
            <div className="info-container__main-content">
                <h3 className="main-content__title">Робот-Геокодер</h3>
                <p className="main-content__text">инструмент для работы с адресами и координатами</p>
                <p className="main-content__text">по всей России. Преобразует адреса в координаты и обратно,</p>
                <p className="main-content__text">анализирует и структурирует адресные данные</p>
                <h4 className="main-content__sub-title">Больше. Точнее. Богаче.</h4>
            </div>
            <div className="info-container__record-container">
                <div
                    className="record-container__record-item"
                    onMouseEnter={() => setShowMore(1)}
                    onMouseLeave={() => setShowMore(null)}
                    style={{
                        minWidth: "135px",
                        maxWidth: "135px"
                    }}
                >
                    {showMore && showMore === 1 ? <p className="record-item__text">40.3 млн объектов с адресами на всю Россию</p> : <h1 className="record-item__title">40<br />млн</h1>}
                </div>
                <div
                    className="record-container__record-item"
                    onMouseEnter={() => setShowMore(2)}
                    onMouseLeave={() => setShowMore(null)}
                    style={{
                        minWidth: "135px",
                        maxWidth: "135px"
                    }}
                >
                    {showMore && showMore === 2 ? <p className="record-item__text">В среднем каждый объект имеет 5.6 адресных признаков</p> : <h1 className="record-item__title">5.6<br /> признаков</h1>}
                </div>
                <div
                    className="record-container__record-item"
                    onMouseEnter={() => setShowMore(3)}
                    onMouseLeave={() => setShowMore(null)}
                    style={{
                        minWidth: "135px",
                        maxWidth: "135px"
                    }}
                >
                    {showMore && showMore === 3 ? <p className="record-item__text">Производительность Геокодера до 140 запросов в секунду</p> : <h1 className="record-item__title">140<br />шт/сек</h1>}
                </div>
                <div
                    className="record-container__record-item"
                    onMouseEnter={() => setShowMore(4)}
                    onMouseLeave={() => setShowMore(null)}
                    style={{
                        minWidth: "135px",
                        maxWidth: "135px"
                    }}
                >
                    {showMore && showMore === 4 ? <p className="record-item__text">Производительность Разборщика до 500 запросов в секунду</p> : <h1 className="record-item__title"> до 500<br />шт/сек</h1>}
                </div>
                <div
                    className="record-container__record-item"
                    onMouseEnter={() => setShowMore(5)}
                    onMouseLeave={() => setShowMore(null)}
                    style={{
                        minWidth: "135px",
                        maxWidth: "135px"
                    }}
                >
                    {showMore && showMore === 5 ? <p className="record-item__text">Стоимость сервиса Геокодера от 30 копеек за запрос, Разборщика - от 10 копеек</p> : <h1 className="record-item__title">от 30<br />коп/шт</h1>}
                </div>
            </div>
        </div>

        <div className="compare-container" id="compare-container">

            <p className="compare-container__compare-item--background-color border-b border-r"></p>
            <p className="compare-container__compare-item--background-color border-b border-r">Делают все</p>
            <p className="compare-container__compare-item--background-color border-b border-r">Некоторые</p>
            <p className="compare-container__compare-item--background-color border-b"><b>Геокодер</b></p>

            <p className="compare-container__compare-item--background-color border-b border-r">Точность геоданных</p>
            <p className="compare-container__compare-item border-b border-r">Погрешность 10–50 м</p>
            <p className="compare-container__compare-item border-b border-r">Погрешность 5–10 м</p>
            <p className="compare-container__compare-item border-b">Точность 1–5 м<a className="external-link" href="https://ksdm.geosamara.ru/oap">благодаря ОАП</a></p>

            <p className="compare-container__compare-item--background-color border-b border-r">Актуальность</p>
            <p className="compare-container__compare-item border-b border-r">Обновление раз в год</p>
            <p className="compare-container__compare-item border-b border-r">Обновление раз в квартал</p>
            <p className="compare-container__compare-item border-b">
                <div className="compare-item__content">
                    Постоянное ежемесячное обновление <a className="external-link" href="https://rk.geosamara.ru">за счет работы Робот-Картографа</a>
                </div>
            </p>

            <p className="compare-container__compare-item--background-color border-b border-r">Полнота ответа</p>
            <p className="compare-container__compare-item border-b border-r">Адрес дома</p>
            <p className="compare-container__compare-item border-b border-r">Адрес, код ФИАС, организации</p>
            <p className="compare-container__compare-item border-b">Структурный адрес, кадастровые номера, код ФИАС, организации</p>

            <p className="compare-container__compare-item--background-color border-b border-r">Признаки места</p>
            <p className="compare-container__compare-item border-b border-r">Адрес</p>
            <p className="compare-container__compare-item border-b border-r">Адрес либо координаты отдельными методами</p>
            <p className="compare-container__compare-item border-b">Любая комбинация: адрес, координаты, кадастровые номера, коды ФИАС, названия организаций</p>

            <p className="compare-container__compare-item--background-color border-b border-r">Охват</p>
            <p className="compare-container__compare-item border-b border-r">Только крупные города</p>
            <p className="compare-container__compare-item border-b border-r">Часть регионов РФ с неполными данными по удаленным территориям</p>
            <p className="compare-container__compare-item border-b"><b>Вся Россия</b>+ адаптация под любые территории</p>

            <p className="compare-container__compare-item--background-color border-b border-r">Непротиворечивость</p>
            <p className="compare-container__compare-item border-b border-r">Есть дубли и ошибки</p>
            <p className="compare-container__compare-item border-b border-r">Ручная проверка</p>
            <p className="compare-container__compare-item border-b">Автоматизированная верификация по 8-10 источникам устраняет противоречия</p>

            <p className="compare-container__compare-item--background-color border-b border-r">Стоимость</p>
            <p className="compare-container__compare-item border-b border-r">Подписка по времени или объему</p>
            <p className="compare-container__compare-item border-b border-r">Умеренные тарифы, бесплатный период</p>
            <p className="compare-container__compare-item border-b">Гибкая цена (без скрытых платежей) от 30 копеек/шт и бесплатный объем</p>

            <p className="compare-container__compare-item--background-color border-b border-r">Совместимость</p>
            <p className="compare-container__compare-item border-b border-r">API JSON/XML</p>
            <p className="compare-container__compare-item border-b border-r">API и интеграции</p>
            <p className="compare-container__compare-item border-b">
                <div className="compare-item__content">
                    <a className="external-link" href="https://rk.geosamara.ru/geocoder/swagger-ui/index.html">OpenAPI</a>, <a className="external-link" href="https://rk.geosamara.ru/lk/MyDatasets">пакетная обработка в ЛК</a>, плагин для Excel
                </div>
            </p>

            <p className="compare-container__compare-item--background-color border-r">Производительность</p>
            <p className="compare-container__compare-item border-r">Задержка не более 500 мс</p>
            <p className="compare-container__compare-item border-r">не более 150 мс</p>
            <p className="compare-container__compare-item">до 140 ответов в секунду от Геокодера, до 500 от Разборщика, есть тарифы без ограничений интенсивности</p>

        </div>


        <div className="compare-img-container">
            <div className="compare-img-container-row">
                <img src={CompareTruthImg} className="compare-img" />
                <img src={CompareTimeImg} className="compare-img" />
            </div>
            <div className="compare-img-container-row">
                <p>Испытание проведено на 10 регионах России, по тысяче проверенных адресов из ЕГРН в каждом регионе. Критерий верного ответа - географическая близость. Свяжитесь с нами, если хотите узнать больше об испытании.</p>
            </div>
        </div>


        <div className="functions-container" id="functions-container">
            <h1 className="functions-container__title">Возможности</h1>
            <div className="functions-container-list" >
                <div className="functions-container__functions-item">
                    <h1 className="functions-item__title">Прямое геокодирование</h1>
                    <p className="functions-item__text">вы указываете адрес, а Геокодер возвращает точные координаты и характеристики здания</p>
                </div>
                <div className="functions-container__functions-item">
                    <h1 className="functions-item__title">Обратное геокодирование</h1>
                    <p className="functions-item__text">вы задаёте координаты, а Геокодер находит адрес здания в этой точке (или ближайшего к ней объекта)</p>
                </div>
                <div className="functions-container__functions-item">
                    <h1 className="functions-item__title">Разборщик</h1>
                    <p className="functions-item__text">Превратить неаккуратный адрес в чёткие структурированные компоненты (топонимы и признаки) </p>
                </div>
            </div>
        </div>

        <div className="info-container--more-top-margin" id="info-container-more-info">
            <div className="info-container__main-content--fit-content">
                <h3 className="main-content__title" style={{ fontSize: "50px" }}>Для кого</h3>
            </div>
            <div className="info-container__problems-container">
                <div className="problems-container__problem-item">
                    <div className="problem-item__text">Обогащаем геоданные адресами, а адресные данные - геопривязкой для компаний, у которых нет собственной инфраструктуры</div>
                    <div className="problem-item__title">Для разработчиков геосервисов</div>
                </div>
                <div className="problems-container__problem-item">
                    <div className="problem-item__text">Cоздаём реестры с адресной привязкой, устраняем противоречия в данных</div>
                    <div className="problem-item__title">Для государственных служб и муниципалитетов</div>
                </div>
                <div className="problems-container__problem-item">
                    <div className="problem-item__text">Точно определяем адреса доставки даже при неполных исходных данных</div>
                    <div className="problem-item__title">Для логистических компаний и служб доставки</div>
                </div>
            </div>
        </div>

        <div className="advantages-container" id="advantages-container">
            <h1 className="advantages-container__title">Преимущества</h1>
            <div className="advantages-container__advantages-list">

                <div className="advantages-list__advantage-item">
                    <div className="advantage-item__text">Работает на Объединённом Адресном Плане (ОАП) —  собственном продукте платформы «Робот-Картограф», который регулярно обновляется и автоматически проверяется.</div>
                    <div className="advantage-item__title">Надёжная информационная основа</div>
                </div>

                <img src={NextArrow} alt="" className="advantage-list__next" />

                <div className="advantages-list__advantage-item">
                    <div className="advantage-item__text">Использует до 8 источников с адресной информацией, чтобы обеспечить многократное подтверждение</div>
                    <div className="advantage-item__title">Полные и актуальные данные</div>
                </div>

                <img src={NextArrow} alt="" className="advantage-list__next" />

                <div className="advantages-list__advantage-item">
                    <div className="advantage-item__text">Использует три алгоритма поиска и множество признаков места, чтобы определить наилучшее соответствие</div>
                    <div className="advantage-item__title">Высокая точность</div>
                </div>

                <img src={NextArrow} alt="" className="advantage-list__next" />

                <div className="advantages-list__advantage-item">
                    <div className="advantage-item__text">Можно работать одновременно и «как в Экселе», и через API - кому что удобнее</div>
                    <div className="advantage-item__title">Гибкость использования</div>
                </div>
            </div>
        </div>
*/}

        <div className="sandbox" id="sandbox">
            <div className="sandbox__container">
                <div className="container__top-bar">
                    <input
                        type="text"
                        className="top-bar__input"
                        id="top-bar__input"
                        placeholder='Введите адрес'
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                    />
                    <label htmlFor="top-bar__input" className="top-bar__label">или нажмите на карту</label>
                    <button
                        className="top-bar__button"
                        disabled={address.length === 0}
                        onClick={() => getAddress('geocode')}
                    >Геокодировать</button>
                    <p>или</p>
                    <button
                        className="top-bar__button--second"
                        disabled={address.length === 0}
                        onClick={() => getAddress('decompose')}
                    >Разобрать</button>
                </div>
                <div className="container__bottom-bar">
                    <div id="map" className="bottom-bar__map" ref={mapElement} />
                    <ReactJson
                        src={lastResponse ? lastResponse : {}}
                        displayObjectSize={false}
                        displayDataTypes={false}
                        collapsed={1}
                        enableClipboard={true}
                        style={{ flex: 2, maxHeight: '100%', overflow: 'auto' }}
                    />
                </div>
                <div className="sandbox__footer">
                    <hr />
                    OpenAPI: <a href="https://rk.geosamara.ru/geocoder/swagger-ui/index.html" className="external-link"> https://rk.geosamara.ru/geocoder/swagger-ui/index.html</a>
                    <br />
                    Получите токен для работы с API в <a className="external-link" href="https://rk.geosamara.ru/lk/MyDatasets">Личном кабинете</a>

                </div>
            </div>

        </div>




        {/* <div className="tarifs-container" id="tarifs-container">
            <h1 className="tarifs-container__title">Тарифы</h1>
            <div className="tarifs-container__table">

                <p className="table__item--background-color border-b border-r"></p>
                <p className="table__item--background-color border-b border-r">Лимит в час</p>
                <p className="table__item--background-color border-b border-r">Лимит в сутки</p>
                <p className="table__item--background-color border-b border-r">Стоимость одного геокодирования</p>
                <p className="table__item--background-color border-b">Стоимость одного разбора</p>

                <p className="table__item--background-color border-b border-r">Начальный</p>
                <p className="table__item border-b border-r">1 000</p>
                <p className="table__item border-b border-r">10 000</p>
                <p className="table__item border-b border-r">1 рубль</p>
                <p className="table__item border-b">1 рубль</p>

                <p className="table__item--background-color border-b border-r">Средний</p>
                <p className="table__item border-b border-r">10 000</p>
                <p className="table__item border-b border-r">100 000</p>
                <p className="table__item border-b border-r">40 копеек</p>
                <p className="table__item border-b">20 копеек</p>

                <p className="table__item--background-color border-r">Максимальный</p>
                <p className="table__item border-r">100 000</p>
                <p className="table__item border-r">1 000 000</p>
                <p className="table__item border-r">30 копеек</p>
                <p className="table__item">10 копеек</p>

            </div>
        </div>

        <div className="about-company" id="about-company">
            <div className="about-company__left-side">
                <img src={SAMISLogo} alt="" className="left-side__company-logo" />
            </div>
            <div className="about-company__right-side">
                <h1 className="right-side__title">О компании</h1>
                <p className="right-side__about-company">АО «Самара-Информспутник» — компания с опытом работы более 25 лет в сфере геоинформатики вышла в 2025 году на федеральный уровень под брендом «САМИС».  Компания занимается созданием наукоёмкой продукции в области информационных технологий, её внедрением в опытно-конструкторские разработки, производство и социальную сферу.</p>
            </div>
        </div>

        <div className="clients" id="clients">
            <h1 className="clients__title">Клиенты САМИС</h1>
            <div className="clients__clients-list">
                <div className="clients-list__item">
                    <img src={CatImg} alt="" className="item__user-avatar" />
                    <p className="item__user-name">Иванов Иван Иванович</p>
                    <p className="item__user-position">Министр</p>
                </div>
                <div className="clients-list__item">
                    <img src={CatImg} alt="" className="item__user-avatar" />
                    <p className="item__user-name">Иванов Иван Иванович</p>
                    <p className="item__user-position">Министр</p>
                </div>
                <div className="clients-list__item">
                    <img src={CatImg} alt="" className="item__user-avatar" />
                    <p className="item__user-name">Иванов Иван Иванович</p>
                    <p className="item__user-position">Министр</p>
                </div>
                <div className="clients-list__item">
                    <img src={CatImg} alt="" className="item__user-avatar" />
                    <p className="item__user-name">Иванов Иван Иванович</p>
                    <p className="item__user-position">Министр</p>
                </div>
                <div className="clients-list__item">
                    <img src={CatImg} alt="" className="item__user-avatar" />
                    <p className="item__user-name">Иванов Иван Иванович</p>
                    <p className="item__user-position">Министр</p>
                </div>
                <div className="clients-list__item">
                    <img src={CatImg} alt="" className="item__user-avatar" />
                    <p className="item__user-name">Иванов Иван Иванович</p>
                    <p className="item__user-position">Министр</p>
                </div>
            </div>
        </div>
        

        <div className="contact-us-container" id="contact-us-container">
            <form
                className="contact-us-container__left-side"
                onSubmit={(e) => {
                    e.preventDefault();
                    idInContainer && sendMetricContacts(idInContainer, userContact.email, 'захотел связаться о ', Config.texts.appName)
                }}
            >
                <label htmlFor="email-input">Email</label>
                <input id="email-input" type="text" placeholder='Ваш email' value={userContact.email} onChange={(e) => updUserContact('email', e.target.value)} />
                <label htmlFor="email-input">Как вас зовут?</label>
                <input id="name-input" type="text" placeholder='Ваше имя' value={userContact.name} onChange={(e) => updUserContact('name', e.target.value)} />
                <label htmlFor="email-input">Номер телефона</label>
                <input id="phone-input" type="text" placeholder='Номер телефона' value={userContact.phone} onChange={(e) => updUserContact('phone', e.target.value)} />
                <label htmlFor="email-input">Комментарий</label>
                <textarea id="comment-input" value={userContact.comment} onChange={(e) => updUserContact('comment', e.target.value)} />
                <button type='submit'>Отправить</button>
            </form>
            <div className="contact-us-container__right-side">
                <div className="right-side__title">Свяжитесь с нами</div>
                <a href="tel:+78462556371">+7 (846) 255-63-71</a>
                <a href="mailto:team@geosamara.ru">team@geosamara.ru</a>
                <p className="right-side__addres">Самара, проспект Карла Маркса, дом 192, офис 717</p>
                <div className="navigation__social-container">
                    <a href="https://vk.com/geosamara_vk" target="_blank" style={{ backgroundImage: `url(${VKLogo})` }} className="social-container__social-item" />
                    <a href="https://t.me/geosamara" target="_blank" style={{ backgroundImage: `url(${TGLogo})` }} className="social-container__social-item" />
                </div>
            </div>
        </div>

        <div className="footer">
        </div>

        <div className="void" style={{ width: '100%', minHeight: '500px' }} /> */}
    </>
}